import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose,combineReducers} from "redux";
import { logger } from "redux-logger";
import createSagaMiddleware from "redux-saga";
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'

import "./index.scss";
import App from "./App";
import reducers from "./redux/reducers";
import sagas from "./redux/sagas";
import profileReducer from "./redux/profile/reducer";
import {postListReducer} from "./redux/posts/reducer";
import creditzReducer from "./redux/creditz/reducer";
import settingsReducer from "./redux/settings/reducer";
import connectionReducer from "./redux/connections/reducer"
import userReducer from "./redux/users/reducer"
const reducer= combineReducers({
  profile:profileReducer,
  settings:settingsReducer,
  connection:connectionReducer,
  creditz:creditzReducer,
  users:userReducer,
  postList:postListReducer,
})
const sagaMiddleware = createSagaMiddleware();
const middlewares = [logger, sagaMiddleware,thunk ];
const store = createStore(reducer, composeWithDevTools(applyMiddleware(...middlewares)));
sagaMiddleware.run(sagas);

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);


